<template>
  <div id="appdownload">
    <div id="content">
      <div class="tabbox">
        <div class="tabcon teacher font13 pointer" :class="tabname == 1?'on':''" @click="tabChange(1)">教师App</div>
        <div class="tabcon student font13 pointer" :class="tabname == 2?'on':''" @click="tabChange(2)">学生手机App</div>
        <div class="tabcon pad font13 pointer" :class="tabname == 3?'on':''" @click="tabChange(3)">学生平板App</div>
      </div>
      <div class="downbox">
        <div class="downcon clearfix downteacher" v-show="tabname == 1">
          <div class="imgbox"><img src="../../../static/images/jiaoshiappbg.png" alt=""></div>
          <div class="downtextbox">
            <div class="downtitle">让老师简单高效备课</div>
            <div class="qrbox clearfix">
              <img src="../../../static/images/jiaoshiewm.png" alt="">
              <span>教师手机App</span>
            </div>
            <div class="downintro">爱学堂，源于美国EDX，依托于清华大学，是中国在线教育的领军品牌。由拥有多年经验的教师团队倾情打造精彩课程内容;区别于传统网校，精编动画对知识进行讲解更加透彻;让知识学习变得更加快乐!更有线上化布置班级任务的全新体验，支持支持拍照、语音、微课、讨论一键布置，生成班级报告，任务/作业完成情况一目了然!</div>
          </div>
        </div>
        <div class="downcon clearfix downstudent" v-show="tabname == 2">
          <div class="imgbox"><img src="../../../static/images/xueshengappbg.png" alt=""></div>
          <div class="downtextbox">
            <div class="downtitle">让孩子快乐轻松学习</div>
            <div class="qrbox clearfix">
              <img src="../../../static/images/xueshengewm.png" alt="">
              <span>学生手机App</span>
            </div>
            <div class="downintro">爱学堂，首创中小学全教材动漫课程，将课堂的知识用动漫的方式来讲解！拥有从一年级至高三年级，所有科目同版本同教材的海量动漫教学视频！知识换种方式学习，让孩子更容易吸收，让学习更加高效！</div>
          </div>
        </div>
        <div class="downcon clearfix downpad" v-show="tabname == 3">
          <div class="imgbox"><img src="../../../static/images/padbg.png" alt=""></div>
          <div class="downtextbox">
            <div class="downtitle">让孩子快乐轻松学习</div>
            <div class="qrbox clearfix">
              <img src="../../../static/images/padewm.png" alt="">
              <span>学生平板App</span>
            </div>
            <div class="downintro">爱学堂，首创中小学全教材动漫课程，将课堂的知识用动漫的方式来讲解！拥有从一年级至高三年级，所有科目同版本同教材的海量动漫教学视频！知识换种方式学习，让孩子更容易吸收，让学习更加高效！<br />爱学堂，也是教育部在线教育研究中心基础教育频道的研究交流和成果应用平台，未来的学习就是这种方式！</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import bus from '../../assets/eventBus/enentBus.js'
export default {
    name:'appDownload',
    props:{

    },
    watch:{


    },
    data () {
      return {
        // isLogin:false
        tabname:1
      }

    },
    mounted(){


    },
    methods: {
      tabChange(id){
        if(this.tabname == id) return
        console.log(id)
        this.tabname = id;
      },
      
    },
}
</script>
<style>
  /* #headtop {
    background-color: #f4f4f4!important;
  } */
</style>
<style scoped>
#appdownload {
  padding-top: 100px;
  position: relative;
}

.tabbox {
  padding-top: 100px;
}
.tabcon {
  display: inline-block;
  margin: 0 70px;
  padding-top: 50px;
  overflow: hidden;
  color: #A5A5A5;
  font-weight: 500;
}
.teacher {
  background: url(/static/images/appdjiaoshi.png) no-repeat center 3px;
  background-size: 35px 35px;
}
.teacher.on {
  background: url(/static/images/appdjiaoshibg.png) no-repeat center 3px;
  background-size: 35px 35px;
}
.student {
  background: url(/static/images/appdxs.png) no-repeat center 3px;
  background-size: 27px 35px;
}
.student.on {
  background: url(/static/images/appdxsbg.png) no-repeat center 3px;
  background-size: 27px 35px;
}
.pad {
  background: url(/static/images/appdpad.png) no-repeat center 3px;
  background-size: 39px 37px;
}
.pad.on {
  background: url(/static/images/appdpadbg.png) no-repeat center 3px;
  background-size: 39px 37px;
}
.tabcon.on {
  color: #3583FF;
}
.downbox {
  width: 1200px;
  height: 494px;
  margin: 100px auto;
  background: url(/static/images/appdownloadbg.png) no-repeat ;
  background-size: 1200px 494px;
}
.downcon {
  display: flex;
}
.downcon .imgbox {
  height: 494px;
  flex: 5;
  text-align: right;
}
.downtextbox {
  flex: 6;
  text-align: left;
}
.downcon .imgbox img {
  height: 100%;
}
.downintro {
  width: 70%;
  font-size: 13px;
  margin-top: 25px;
  color: #999;
  line-height: 1.8;
}
.downtitle {
  font-size: 52px;
  color: #3583FF;
  font-weight: 500;
  padding-top: 50px;
}
.qrbox {
  margin-top: 20px;
}
.qrbox img {
  float: left;
  width: 126px;
  height: 126px;
}
.qrbox span {
  margin-left: 20px;
  font-size: 32px;
  color: #010101;
  font-weight: 500;
}
.downpad .imgbox {
  height: 394px;
  padding-top: 50px;
}
.downpad .imgbox img {
  height: 394px;
  position: relative;
  right: -20px;
}
.downpad .downtitle {
  padding-top: 40px;
}
.downpad .downtextbox {
  padding-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/appDownload/appDownload.vue